import { useAndroidBackButton } from '@/hooks/useAndroidBackButton';

const AndroidBackButtonHandler = () => {
  useAndroidBackButton();
  return null;
};

export default AndroidBackButtonHandler;
